// eslint-disable-next-line import/prefer-default-export
export function notNil(x) {
    return x !== undefined && x !== null;
}
export function connectionNodes(connection) {
    const { edges } = connection;
    if (!edges) {
        return [];
    }
    return edges
        .filter(notNil)
        .map((edge) => edge.node)
        .filter(notNil);
}
export function pick(obj, ...keys) {
    const ret = {};
    keys.forEach((key) => {
        ret[key] = obj[key];
    });
    return ret;
}
// Like lodash mapValues, but retain key type
export function mapValues(object, callback) {
    const result = {};
    Object.entries(object).forEach(([key, value]) => {
        result[key] = callback(value, key);
    });
    return result;
}
//# sourceMappingURL=typescriptUtils.js.map